import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import MoodUserDetail from './MoodUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyMoodUserDetail } from './companyMoodApi';

/**
 * Company Mood Tracking → one employee's/member's mood profile.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CMoodUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Mood Profile | Shoorah</title>
      </Helmet>
      <MoodUserDetail
        fetcher={fetchCompanyMoodUserDetail}
        backPath={`/${slug}/mood/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CMoodUserDetail;
